import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CenterPanel from './centerPanel';
import RightPanelTop from './rightPanelTop';
import PopupHeader from '../../popupHeader';
import Modal from '../../../shared/modal/content';
import { suspendAccessWaitingArea } from '../../../../actions/waitingArea.js';

export default function ContentSuspendWaitingArea(props) {
  const showSuspendWAModal = useSelector((state) => state.modalReducer.showSuspendWAModal);
  const [getSuspendWAMsgForCallers, setGetSuspendWAMsgForCallers] = useState('');
  const [getSuspendWAMsgForProviders, setGetSuspendWAMsgForProviders] = useState('');

  const waitingArea = props.waitingArea;

  let suspendWAModal = showSuspendWAModal ? (
    <Modal show={showSuspendWAModal} hideWhenClickAway={false} className="ui modal suspend-waiting-area">
      <PopupHeader
        title={APP.LANGUAGE.SuspendWaitingAreaModal.Title}
        subtitle={waitingArea.name + ' (' + waitingArea.organisationAbbreviatedName + ')'}
        helpLink={APP.EXTERNAL_LINKS.ViewOneWaitingArea.HelpSuspendOrResume}
      />
      <div className="content">
        <div className="main-ui-container meeting-room-create-update">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">
                <RightPanelTop
                  waitingArea={waitingArea}
                  getSuspendWAMsgForCallers={getSuspendWAMsgForCallers}
                  getSuspendWAMsgForProviders={getSuspendWAMsgForProviders}
                />
              </div>
            </div>
            <CenterPanel
              waitingArea={waitingArea}
              setGetSuspendWAMsgForCallers={setGetSuspendWAMsgForCallers}
              setGetSuspendWAMsgForProviders={setGetSuspendWAMsgForProviders}
            />
            <div className="bottom-rail-with-left-and-right-content mrtnull">
              <RightPanelTop
                waitingArea={waitingArea}
                getSuspendWAMsgForCallers={getSuspendWAMsgForCallers}
                getSuspendWAMsgForProviders={getSuspendWAMsgForProviders}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  ) : (
    ''
  );

  return <div>{suspendWAModal}</div>;
}
